import React from "react";
import AppLayout from "../components/AppLayout";
import DashboardHeroe from "../components/DashboardHeroe";
import DashboardPhaseTwo from "../components/DashboardRowTwo";

const DashboardPage: React.FC = () => {
  return (
    <AppLayout>
      <DashboardHeroe />
      <DashboardPhaseTwo />
    </AppLayout>
  );
};

export default DashboardPage;
